var nivo001;
window.addEventListener('load', function() {
	setSVGLogo();
	setKV();
	if($(window).width()>767){
		nivo001 = nivoSlider($("#nslider"));
	}else{
		nivo001 = nivoSlider($("#nsliderSP"));
	}
	$("#sliderWrapperWrapper").addClass("fadeIn");

	$(".bakes-mothers-day-2022-products").on('invew',function(event, isInView) {alert("invew");});

	$(window).bind("scroll", function() {
		var sctop = $(window).scrollTop();
		var productInfoTop = $(".productInfo").offset().top;
		if(productInfoTop < sctop){
			var d = (productInfoTop - sctop)/-1.5;
			//console.log(d);
			$(".bgWrapper").css("background-position","center "+d+"px");
			$(".spBgWrapper").addClass("isShow");
		}else{
			$(".bgWrapper").css("background-position","center top");
			$(".spBgWrapper").removeClass("isShow");
		}

		if(sctop > $(window).height()/2 && sctop < $(window).height() + $(".productInfo").height()){
			$(".spBgWrapper").addClass("fadeIn");
		}else{
			console.log("fadeout");
			$(".spBgWrapper").removeClass("fadeIn");
		}
	});

});
function nivoBeforeChange(n){
	//console.log(n);
	if(n==0){
		//$("#svgLogoWrapper").fadeOut();
		$("#sliderWrapperWrapper").addClass("secondImage");
	}
	if(n==4){
		//$("#svgLogoWrapper").fadeOut();
		$("#sliderWrapperWrapper").removeClass("secondImage");
	}
}
window.addEventListener('resize', function() {
	setKV();
});
function setSVGLogo(){
	setTimeout(function(){
		var elm = document.getElementById('svgLogo');
		$(elm).find("#wrap_all").addClass("start");
	},1000);
}

function setKV(){
	var headerHeight = $("#shopify-section-fr-header").height();
	$("#sliderWrapperWrapper").css("margin-top",headerHeight+"px");
	$("#sliderWrapperWrapper").css("height","calc(100vh - "+headerHeight+"px)");
	var pw = $("#sliderWrapperWrapper").width();
	var ph = $("#sliderWrapperWrapper").height();
	var cw = $("#sliderWrapper").width();
	var ch = $("#sliderWrapper").height();
	var dw = pw/cw;
	var dh = ph/ch;
	var trsfm = dw;
	if(dh>dw){
		trsfm = dh;
	}
	trsfm+=0.1;
	var targetW = cw * trsfm;
	var targetH = ch * trsfm;
	$("#sliderWrapper").width(targetW);
	$("#sliderWrapper").height(targetH);
	var targetSlider = "#nslider";
	var bottomDiv = 2;
	if($(window).width()<768){
		var targetSlider = "#nsliderSP";
		var bottomDiv = 1;
	}

	$(targetSlider).width(targetW);
	$(targetSlider).height(targetH);
	$("#sliderWrapper").css("left",($("#sliderWrapperWrapper").width()-$(targetSlider).width())/2+"px");
	$("#sliderWrapper").css("top",($("#sliderWrapperWrapper").height()-$(targetSlider).height())/bottomDiv+"px");
	//$("#nslider").css("transform","scale("+trsfm+")");
	//console.log("sliderWrapperWrapper");
}